module.exports = __webpack_public_path__ + "static/colorful_particles-e2825ebcafefe9dbfb99c8ebf9e7dc58.svg";